import React from "react";

interface NumericCellProps {
  value: number | "" | null | undefined;
  unit?: string;
}

/** Right-aligned monospace numeric with an optional unit suffix; muted dash when empty. */
const NumericCell: React.FC<NumericCellProps> = ({ value, unit }) => {
  if (value === "" || value == null) {
    return <span className="tw-text-muted-foreground">—</span>;
  }

  return (
    <span className="tw-font-mono">
      {value}
      {unit ? ` ${unit}` : ""}
    </span>
  );
};

export default NumericCell;
